module.exports = __webpack_public_path__ + "media/images/lb/501-729f4d654b70675f0d408ff3e6d52194.svg";